import { LitElement, html } from "lit";
import { getText } from "../utils/language";
import { getViewMode, setViewMode } from "../utils/viewMode";
/**
 * A component for toggling between text and image view modes
 *
 * @element viewtoggle-v1
 */
export class ViewToggle extends LitElement {
    constructor() {
        super();
        this._toggle = () => {
            const next = this._mode === "image" ? "text" : "image";
            setViewMode(next);
        };
        this._mode = getViewMode();
        this.boundHandlers = {
            viewModeChanged: ((e) => {
                const mode = e.detail === "image" ? "image" : "text";
                if (this._mode !== mode) {
                    this._mode = mode;
                }
            }),
            languageChanged: (() => {
                this.requestUpdate();
            }),
        };
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("view-mode-changed", this.boundHandlers.viewModeChanged);
        window.addEventListener("language-changed", this.boundHandlers.languageChanged);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("view-mode-changed", this.boundHandlers.viewModeChanged);
        window.removeEventListener("language-changed", this.boundHandlers.languageChanged);
    }
    render() {
        const label = this._mode === "image" ? getText("hideImage") : getText("viewImage");
        return html `
      <ds-button variant="primary" @click=${this._toggle}>${label}</ds-button>
    `;
    }
}
ViewToggle.properties = {
    _mode: { type: String, state: true },
};
customElements.define("viewtoggle-v1", ViewToggle);
